import { VContainer } from 'vuetify/lib/components/VGrid';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VContainer,[(_vm.$store.getters['Profile/loadingReferee'])?_c(VOverlay,{attrs:{"z-index":"10","color":"#000000","opacity":".6"}},[_c(VProgressCircular,{attrs:{"size":"100","width":"4","indeterminate":"","color":"primary"}})],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }